module.exports = __webpack_public_path__ + "img/ldorina_cover.7f57b229.jpg";